import { collection } from "@doitintl/models-types";

@collection("permissions")
export class PermissionModel {
  desc?: string;

  title!: string;
}
